import { useSelector } from 'react-redux'
import * as R from 'ramda'

export const useCandidateGroupData = () => {
  const { candidates } = useSelector((state: any) => state.orm)

  const pks = R.keys(candidates?.meta?.selected) || []

  const count = R.length(pks)

  const applicants = R.filter(
    ({ id }) => R.includes(id?.toString(), pks),
    R.values(candidates?.items),
  )

  return {
    state: {
      candidates: applicants,
      count,
      pks,
    },
  }
}
